
import apiClient from '../utils/axiosConfig';
import { useDispatch } from 'react-redux';



export const login = async(data) => {
    try {
        const response=await apiClient.post(`/user/login`,data)
        console.log("response data",response)
        return response.data
    } catch (error) {
        console.error('Error details:', error);
        return error.response.data
    }
   
     
  };

export const verifyOTP = async(data) => {
    try {
        const response=await apiClient.post(`/user/verifyOtp`,data)
        console.log("response data",response)
        return response.data
    } catch (error) {
        console.error('Error details:', error);
    }
   
     
  };


  export const sendResetPasswordLink=async(data)=>{
    try {
        const response=await apiClient.post(`/user/forgot-password`,data)
        console.log("response data",response)
        return response.data
    } catch (error) {
        console.error('Error details:', error);
        return error.response.data
    }
  }

  export const verifyForgotPasswordToken = (token) => {
    return apiClient
      .get(`/user/forgot-password/verify/token?token=${token}`)
      .then(async (response) => response.data)
      .catch((error) => error.response.data);
  };
  
export const resetPassword = (data) => {
    return apiClient
      .post(`/user/forgot-password/change/password`, data)
      .then(async (response) => response.data)
      .catch((error) => error.response.data);
  };

  export const changePassword=async(data)=>{
    try {
      const response =await apiClient.post(`/user/reset/password`,data)
      console.log("Response for change password api",response.data)
      return response.data
    } catch (error) {
      console.log("error for change password api",error)
      return error.response.data
    }

  }

  export const changeUserProfilePic=async(formdata)=>{
    try {
      const response =await apiClient.post(`/user/image/upload`,formdata,

        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      )
      console.log("Response for change User PIcture api",response.data)
      return response.data
    } catch (error) {
      console.log("error for change User PIcture api",error)
      return error.response.data
    }
  }


  export const createInvestor=async(formData)=>{
    try{
        const response=await apiClient.post(`/investor/users`,formData,

          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          }
        )
        console.log("response data",response)
        return response.data
    }catch(error){
        console.error('Error details:', error);
        return error.response.data
    }
  }

  export const editInvestor=async(formData)=>{
    try {
        const response= await apiClient.put(`/investor/users`,formData,

          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          }
        )
        console.log("response data",response)
        return response.data
    } catch (error) {
        console.log("Error in edit investor api",error)
        return error.response.data
    }
  }

  export const getAllInvestorDetails=async(data)=>{
    try{
        const response=await apiClient.get(`/investor/users?user_type=${data.user_type}&page_no=${data.page_no}&per_page=${data.per_page}`,)
        console.log("response data",response)
        return response.data
    }catch(error){
        console.error('Error details:', error);
        return error.response.data
    }
  }

  // /get/schemeWise/investor


  export const getAllInvestorDetailsByScheme=async(data)=>{
    try{
        const response=await apiClient.get(`/investor/get/schemeWise/investor?user_type=${data.user_type}&page_no=${data.page_no}&per_page=${data.per_page}&scheme_name=${data.scheme_name}&scheme_class=${data.scheme_class}`,)
        console.log("response data",response)
        return response.data
    }catch(error){
        console.error('Error details:', error);
        return error.response.data
    }
  }

  // Fix for accessibility issues. Issue # VII26-08
  export const getInvestorInfo=async(data)=>{
    try{
        const response=await apiClient.get(`/investor/get/investor/info?user_id=${data?.user_id}&user_email=${data?.user_email}&user_type=${data?.user_type}`)
        console.log("response data",response)
        return response.data
    }catch(error){
        console.error('Error details:', error);
        return error.response?.data || { status: 'error', message: 'Unknown error' }
    }
  }

  export const getInvestorsDropdown=async (data)=>{
    try {
      const response =await apiClient.get(`/investor/get/dropdown?user_type=${data.user_type}`)
      console.log("response data",response)
        return response.data
    } catch (error) {
      console.error('Error in getInvestorsDropdown api', error);
    }
  }

  export const deleteInvestor=async(data)=>{
    try {
        const response= await apiClient.delete(`/investor/users?user_id=${data?.user_id}&&user_email=${data?.user_email}&&user_type=${data?.user_type}`)
        console.log("response data",response)
        return response.data
    } catch (error) {
        console.log("Error in delete investor api",error)
        return error.response.data
    }
  }

 

  export const getSchemeInfoAgainstInvestor=async(data)=>{
    try {
      const response=await apiClient.post(`investor/get/schemeData`,data)
      return response.data
    } catch (error) {
      console.log("getSchemeInfoAgainstInvestor",error)
    }
  }

export const getAllInvestorSchemeReport=async(data)=>{
  try {
    const response=await apiClient.get(`investor/get/report?user_id=${data.user_id}&report_type=${data.report_type}&scheme_id=${data.scheme_id}&scheme_class=${data.scheme_class}&scheme_name=${data.scheme_name}&page_no=${data.page_no}&per_page=${data.per_page}`)
    return response.data

  } catch (error) {
    console.log("Error in getInvestorSchemeReportAgainst api",error)
    return error.response.data
  }
}

  export const createEmployee=async(data)=>{
    try{
        const response=await apiClient.post(`/employee/users`,data)
        console.log("response data",response)
        return response.data
    }catch(error){
        console.error('Error details:', error);
        return error.response.data
    }
  }

  export const editEmployee=async(data)=>{
    try{
        const response=await apiClient.put(`/employee/users`,data)
        console.log("response data",response)
        return response.data
    }catch(error){
        console.error('Error details:', error);
        return error.response.data
    }
  }


  export const getAllEmployeeDetails=async(data)=>{
    try{
        const response=await apiClient.get(`/employee/users?user_type=${data.user_type}&page_no=${data.page_no}&per_page=${data.per_page}`)
        console.log("response data",response)
        return response.data
    }catch(error){
        console.error('Error details:', error);
        return error.response.data
    }
  }

  export const getEmployeeInfo=async(data)=>{
    try{
        const response=await apiClient.get(`/employee/get/info?user_type=${data.user_type}&&user_id=${data.user_id}&&user_email=${data?.user_email}`)
        console.log("response data",response)
        return response.data
    }catch(error){
        console.error('Error details:', error);
        return error.response.data
    }
  }

  export const getAllInvestorDetailsAssignedToEmployeeByScheme=async(data)=>{
    try{
        const response=await apiClient.get(`/employee/get/schemeWise/investor?user_type=${data.user_type}&page_no=${data.page_no}&per_page=${data.per_page}&scheme_name=${data.scheme_name}&scheme_class=${data.scheme_class}&user_id=${data?.user_id}`,)
        console.log("response data",response)
        return response.data
    }catch(error){
        console.error('Error details:', error);
        return error.response.data
    }
  }

  export const getSchemesDropdownAssignedToEmployee=async(data)=>{
    try {
      const response=await apiClient.post("/employee/scheme/dropdown",data)
      console.log("response for get ALL schemes dropdown",response)
      return response.data
    } catch (error) {
      console.log("Error in get scheme dropdown api",error)
    }
  }
  

  export const deleteEmployee=async(data)=>{
    console.log("from api delete ",data)
    try {
        const response= await apiClient.delete(`/employee/users?user_id=${data?.user_id}&&user_email=${data?.user_email}&&user_type=${data?.user_type}`)
        console.log("response data",response)
        return response.data
    } catch (error) {
        console.log("Error in delete investor api",error)
        return error.response.data
    }
  }

  export const createDistributor=async(data)=>{
    try{
        const response=await apiClient.post(`/distributor/users`,data)
        console.log("response data",response)
        return response.data
    }catch(error){
        console.error('Error details:', error);
        return error.response.data
    }
  }
  export const editDistributor=async(data)=>{
    try{
        const response=await apiClient.put(`/distributor/users`,data)
        console.log("response data",response)
        return response.data
    }catch(error){
        console.error('Error details:', error);
        return error.response.data
    }
  }


  export const getAllDistributorDetails=async(data)=>{
    try{
        const response=await apiClient.get(`/distributor/users?user_type=${data.user_type}&page_no=${data.page_no}&per_page=${data.per_page}`)
        console.log("response data",response)
        return response.data
    }catch(error){
        console.error('Error details:', error);
        return error.response.data
    }
  }

  export const searchDistributor=async(data)=>{
    try {
      const response=await apiClient.get(`/distributor/search?search=${data.search}&page_no=${data.page_no}&per_page=${data.per_page}`)
      return response.data
    } catch (error) {
      console.log("Error in search Distributor",error)
    }
  }
  
  export const getDistributorInfo=async(data)=>{
    try{
        const response=await apiClient.get(`/distributor/get/info?user_id=${data?.user_id}&&user_email=${data?.user_email}&&user_type=${data?.user_type}`)
        console.log("response data",response)
        return response.data
    }catch(error){
        console.error('Error details:', error);
        return error.response.data
    }
  }

  export const getDistributorDropdown=async(data)=>{
    try{
        const response=await apiClient.get(`/distributor/get/distributors?user_id=${data?.user_id}&&user_email=${data?.user_email}&&user_type=${data?.user_type}`)
        console.log("response data",response)
        return response.data
    }catch(error){
        console.error('Error details:', error);
    }
  }

  export const deleteDistributor=async(data)=>{
    try {
        const response= await apiClient.delete(`/distributor/users?user_id=${data?.user_id}&&user_email=${data?.user_email}&&user_type=${data?.user_type}`)
        console.log("response data",response)
        return response.data
    } catch (error) {
        console.log("Error in delete distributor api",error)
        return error.response.data
    }
  }


  export const createScheme=async(data)=>{
    try{
        const response=await apiClient.post(`/schemes/create`,data)
        console.log("response data",response)
        return response.data
    }catch(error){
        console.error('Error details:', error);
        return error.response.data
    }
  }

  export const getAllSchemeDetails=async(data)=>{
    try{
        const response=await apiClient.get(`/schemes/get?page_no=${data.page_no}&per_page=${data.per_page}`)
        console.log("response data",response)
        return response.data
    }catch(error){
        console.error('Error details:', error);
        return error.response.data
    }
  }

  export const deleteScheme = async (data) => {
    try {
      const response = await apiClient.delete(
       `/schemes/delete?scheme_id=${data.scheme_id}&scheme_name=${data.scheme_name}`
      );
      console.log("Deleted scheme response:", response);
      return response.data;
    } catch (error) {
      console.error("Error details:", error);
      return error.response.data
    }
  };

export const getSchemesDropdown=async()=>{
  try {
    const response=await apiClient.get("schemes/details")
    console.log("response for get ALL schemes dropdown",response)
    return response.data
  } catch (error) {
    console.log("Error in get scheme dropdown api",error)
  }
}

export const getSchemeInfo=async(data)=>{
  try{
      const response=await apiClient.get(`/schemes/info?scheme_id=${data?.scheme_id }&&scheme_name=${data?.scheme_name}&scheme_class=${data?.scheme_class}`)
      console.log("response data",response)
      return response.data
  }catch(error){
      console.error('Error details:', error);
      return error.response.data
  }
}

export const EditScheme = async (data) => {
  try {
    const response = await apiClient.put(
      `/schemes/update?scheme_id=${data.scheme_id}&scheme_name=${data.scheme_name}`,
      data
    );
    console.log("Updated scheme response:", response);
    return response.data;
  } catch (error) {
    console.error("Error details:", error);
    return error.response.data
  }
};

export const getAllSchemeReportsAgainstSchemeName=async(data)=>{
  try {
    const response=await apiClient.get(`schemes/get/report?report_type=${data.report_type}&scheme_name=${data.scheme_name}&scheme_class=${data.scheme_class}&page_no=${data.page_no}&per_page=${data.per_page}&scheme_id=${data.scheme_id}&user_id=${data.user_id}`)
    return response.data
  } catch (error) {
    console.log("Error in getAllSchemeReportsAgainstSchemeName api",error)
  }
}

export const getAllSchemesTicker=async(data)=>{
  try {
    const response=await apiClient.get(`schemes/get/ticker?page_no=${data.page_no}&per_page=${data.per_page}`)
    return response.data
  } catch (error) {
    console.log("Error in  getAllSchemesTicker api",error)
    return error.response.data
  }
}


export const createTickerForScheme=async(data)=>{
  try {
    const response=await apiClient.post(`schemes/create/ticker`,data)
    console.log("Resposne data",response)
    return response.data
  } catch (error) {
    console.log("Error in create ticker for scheme",error)
    return error.response.data
  }
}

export const deleteTickerForScheme=async(data)=>{
  try {
    const response=await apiClient.delete(`schemes/stop/ticker?scheme_id=${data.scheme_id}&scheme_name=${data.scheme_name}`)
    console.log("Resposne data",response)
    return response.data
  } catch (error) {
    console.log("Error in delete ticker for scheme",error)
    return error.response.data
  }
}



 export const uploadInvestorReport=async(formData)=>{
  try {
    const response=await apiClient.post(`/investor/upload/report`,formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }

    )
    console.log("response data",response)
    return response.data
  } catch (error) {
    console.log("Error in UploadInvestorReport Api",error)
    return error.response.data
  }
 }

export const addEmailTemplate=async(data)=>{
  try {
    const response=await apiClient.post(`emailTemplate/create`,data)
    console.log("response data",response)
    return response.data
  } catch (error) {
    console.log("Error in add email template api",error)
    return error.response.data;
  }
}

export const getAllEmailTemplateDetails=async(data)=>{
  try {
    const response=await apiClient.get(`emailTemplate/get?page_no=${data.page_no}&per_page=${data.per_page}`)
    console.log("response data",response)
    return response.data
  } catch (error) {
    console.log("Error in getAllEmailTemplateDetails api",error)
  }
}

export const deleteEmailTemplate = async (data) => {
  try {
    const response = await apiClient.delete(
     `/emailTemplate/delete?template_id=${data.template_id}`
    );
    console.log("DeletedEmail Response  response:", response);
    return response.data;
  } catch (error) {
    console.error("Error details:", error);
  }
};

export const EditEmailTemplate = async (data) => {
  try {
    const response = await apiClient.put(
     `/emailTemplate/update`,data
    );
    console.log("Edit Email Response  response:", response);
    return response.data;
  } catch (error) {
    console.error("Error details:", error);
    return error.response.data;
  }
};

export const getEmailTemplateInfo=async(data)=>{
  try {
    const response=await apiClient.get(`emailTemplate/emails/info?template_id=${data.template_id}`)
    console.log("response data",response)
    return response.data
  } catch (error) {
    console.log("Error in getEmailTemplatesInfo api",error)
    return error.response.data;
  }
}

export const getEmailTemplatesDropdown=async(data)=>{
  try {
    const response=await apiClient.get(`emailTemplate/emails/dropdown`)
    console.log("response data",response)
    return response.data
  } catch (error) {
    console.log("Error in getEmailTemplatesDropdown api",error)
  }
}


export const uploadSchemeReport=async(formData)=>{
  try {
    const response=await apiClient.post(`schemes/upload/report`,formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    )
    console.log("response data for upload scheme report",response)
    return response.data
  } catch (error) {
    
    console.log("Error in upload scheme report api",error)
    return error.response.data
  }
}


export const uploadExcelFile=async(formData)=>{
  try {
    const response=await apiClient.post(`dashboard/upload-excel`,formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    )
    console.log("response data for upload Excel report",response)
    return response.data
  } catch (error) {
    console.log("Error in upload Excel report api",error)
    return error.response.data
  }
}

export const getProcessedSchemeJsonFromExcel=async(payload)=>{
  try {
    const response=await apiClient.get(`investor/get/dashboard?schema_class=${payload.schema_class}&scheme_name=${payload.scheme_name}&report_type=${payload.report_type}`)
    console.log("response for getProcessedSchemeJsonFromExcel ",response)
    return response.data
  } catch (error) {
    console.log("Error in getProcessedSchemeJsonFromExcel api ",error)
  }
}

export const getAllSchemeOverviewData=async()=>{
  try {
    const response=await apiClient.get(`dashboard/overview/get`)
    console.log("response data for getAllSchemeOverviewData api",response.data)
    return response.data
  } catch (error) {
    console.log("Error in getAllSchemeOverviewData api",error)
  }
}

export const getSchemeOverviewDataByFilter=async(data)=>{
  try {
    const response=await apiClient.get(`dashboard/overview/filter?scheme_name=${data.scheme_name}&scheme_class=${data.scheme_class}`)
    console.log("response data for getSchemeOverviewDataByFilter api",response.data)
    return response.data
  } catch (error) {
    console.log("Error in getSchemeOverviewDataByFilter api",error)
  }
}

export const getAllSchemeFundPerformanceData=async()=>{
  try {
    const response=await apiClient.get(`dashboard/fundPerformance/get`)
    console.log("response data for getAllSchemeFundPerformanceData api",response.data)
    return response.data
  } catch (error) {
    console.log("Error in getAllSchemeFundPerformanceData api",error)
  }
}


export const getSchemeFundPerformanceDataByFilter=async(data)=>{
  try {
    const response=await apiClient.get(`dashboard/fundPerformance/filter?scheme_name=${data.scheme_name}&scheme_class=${data.scheme_class}`)
    console.log("response data for getSchemeFundPerformanceDataByFilter api",response.data)
    return response.data
  } catch (error) {
    console.log("Error in getSchemeFundPerformanceDataByFilter api",error)
  }
}

export const getAllSchemePortfolioData=async()=>{
  try {
    const response=await apiClient.get(`dashboard/portfolio/get`)
    console.log("response data for getAllSchemePortfolioData api",response.data)
    return response.data
  } catch (error) {
    console.log("Error in getAllSchemePortfolioData api",error)
  }
}

export const getSchemePortfolioDataByFilter=async(data)=>{
  try {
    const response=await apiClient.get(`dashboard/portfolio/filter?scheme_name=${data.scheme_name}`)
    console.log("response data for getSchemePortfolioDataByFilter api",response.data)
    return response.data
  } catch (error) {
    console.log("Error in getSchemePortfolioDataByFilter api",error)
  }
}

export const getAllSchemeSectorAllocationData=async()=>{
  try {
    const response=await apiClient.get(`dashboard/sectorAllocation/get`)
    console.log("response data for getAllSchemeSectorAllocationData api",response.data)
    return response.data
  } catch (error) {
    console.log("Error in getAllSchemeSectorAllocationData api",error)
  }
}

export const getSchemeSectorAllocationDataByFilter=async(data)=>{
  try {
    const response=await apiClient.get(`dashboard/sectorAllocation/filter?scheme_name=${data.scheme_name}`)
    console.log("response data for getSchemeSectorAllocationDataByFilter api",response.data)
    return response.data
  } catch (error) {
    console.log("Error in getSchemeSectorAllocationDataByFilter api",error)
  }
}

export const getReportURL=async(data)=>{
  try {
    const response=await apiClient.post(`schemes/getReportURL`,data)
    console.log("response data getReport api",response.data)
    return response.data
  } catch (error) {
    console.log("Error in getReportApi api",error)
    return error.response.data
  }
}

export const getSchemeDocumentUrl=async(data)=>{
  try {
    const response=await apiClient.post(`/investor/SchemeDocumentURL`,data)
    console.log("response data getSchemeDocumentUrl api",response.data)
    return response.data
  } catch (error) {
    console.log("Error in getSchemeDocumentUrl api",error)
    return error.response.data
  }
}
